{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Použiť",
    "CLEAR_BUTTON": "Vymazať",
    "DATE_RANGE_INPUT": {
      "START": "Dátum začiatku",
      "END": "Dátum konca"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "ROZSAH DÁTUMOV",
      "LAST_7_DAYS": "Posledných 7 dní",
      "LAST_30_DAYS": "Posledných 30 dní",
      "LAST_3_MONTHS": "Posledné 3 mesiace",
      "LAST_6_MONTHS": "Posledných 6 mesiacov",
      "LAST_YEAR": "Posledný rok",
      "CUSTOM_RANGE": "Vlastný rozsah dátumov",
      "TODAY": "Dnes",
      "YESTERDAY": "Včera"
    }
  }
}
